// Paylaşılan Card bileşeni — başlık + sayaç badge + filtre + eylem butonları + body
// Kullanım:
//   <Card title="Ülkeler" count={items.length}
//         action={<Button>+ Yeni</Button>}
//         filter={<select>...</select>}>
//     ...table...
//   </Card>
import React from 'react';

export default function Card({
  title,
  count,                  // sayı verilirse "N kayıt" badge gösterilir
  countLabel = 'kayıt',
  filter,                 // sol tarafta filtre kontrolleri
  action,                 // sağ tarafta birincil eylem (örn "+ Yeni")
  noPadding = false,      // body padding'i kaldır (örn DataTable koyacaksanız)
  className = '',
  children,
}) {
  return (
    <div className={'ui-card ' + className}>
      {(title || filter || action) && (
        <div className="ui-card-header">
          <div className="ui-card-header-left">
            {title && <h3 className="ui-card-title">{title}</h3>}
            {typeof count === 'number' && (
              <span className="ui-card-count">{count} {countLabel}</span>
            )}
          </div>
          <div className="ui-card-header-right">
            {filter}
            {action}
          </div>
        </div>
      )}
      <div className={'ui-card-body' + (noPadding ? ' no-padding' : '')}>
        {children}
      </div>
    </div>
  );
}
